<template>
  <router-view />
</template>

<script>
export default {
  name: "AppointmentFreightStatsIndex",
};
</script>

<style scoped>
</style>